import React, { useState } from 'react';
import { Table, Pagination, DateRangePicker, Tag } from 'rsuite';
import { Search, Inbox } from 'lucide-react';
import 'rsuite/dist/rsuite.min.css';

const { Column, HeaderCell, Cell } = Table;

const mockData = [
  { id: 'REQ-101', name: 'Acme Corp', type: 'Abertura de Empresa', status: 'Novo', date: '2026-04-25' },
  { id: 'REQ-102', name: 'Tech Solutions', type: 'Troca de Contador', status: 'Em Análise', date: '2026-04-24' },
  { id: 'REQ-103', name: 'Padaria do Zé', type: 'Consultoria', status: 'Concluído', date: '2026-04-20' },
];

export default function RequestManager() {
  const [data] = useState(mockData);
  const [loading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Novo': return 'orange';
      case 'Em Análise': return 'blue';
      case 'Concluído': return 'green';
      default: return 'cyan';
    }
  };

  const StatusCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props}>
      <Tag color={getStatusColor(rowData[dataKey])}>{rowData[dataKey]}</Tag>
    </Cell>
  );

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 h-full flex flex-col">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="text-xl font-bold text-navy">Gerenciador de Requisições</h1>
          <p className="text-sm text-slate-500">Administre leads e solicitações de clientes.</p>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
            <input 
              type="text" 
              placeholder="Buscar requisição..." 
              className="pl-9 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
            />
          </div>
          <DateRangePicker placeholder="Período" size="md" />
        </div>
      </div>

      <div className="flex-1 min-h-[400px]">
        {data.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-slate-400">
            <Inbox size={48} className="mb-4 text-slate-300" />
            <p className="text-lg font-medium text-slate-600">Nenhuma requisição encontrada</p>
            <p className="text-sm">Os novos leads aparecerão aqui.</p>
          </div>
        ) : (
          <Table
            height={400}
            data={data}
            loading={loading}
            className="rs-theme-light"
          >
            <Column width={120} align="center" fixed>
              <HeaderCell>ID</HeaderCell>
              <Cell dataKey="id" />
            </Column>

            <Column width={200} flexGrow={1}>
              <HeaderCell>Cliente / Empresa</HeaderCell>
              <Cell dataKey="name" />
            </Column>

            <Column width={200}>
              <HeaderCell>Tipo de Solicitação</HeaderCell>
              <Cell dataKey="type" />
            </Column>

            <Column width={150}>
              <HeaderCell>Data</HeaderCell>
              <Cell dataKey="date" />
            </Column>

            <Column width={120}>
              <HeaderCell>Status</HeaderCell>
              <StatusCell dataKey="status" />
            </Column>
            
            <Column width={100} fixed="right">
              <HeaderCell>Ação</HeaderCell>
              <Cell>
                {rowData => (
                  <button className="text-orange-600 hover:text-orange-800 text-sm font-medium">
                    Detalhes
                  </button>
                )}
              </Cell>
            </Column>
          </Table>
        )}
      </div>
      
      <div className="mt-4 pt-4 border-t border-slate-100">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={data.length}
          limitOptions={[10, 20, 50]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={setLimit}
        />
      </div>
    </div>
  );
}
